<template>
    <card-layout :items="categories" v-slot="{item: category, layout}">
        <category-card
            :category="category"
            :title-right="layout == 'wide'"
            :to="link + '/' + category.id"
        />
    </card-layout>
</template>

<script>
import CategoryCard from './CategoryCard.vue'
import CardLayout from './CardLayout.vue'
export default {
    name: 'zoezi-course-category-list',

    zoezi: {
        title: 'Course categories',
        icon: 'mdi-format-list-text',
        addon: 'Courses'
    },

    props: {
        onlyShowCategories: {
            title: 'Categories',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                getItems: () => window.$booking.getCourseCategories(),
                placeholder: 'List all categories'
            },
            default: () => []
        },
        onlyShowSites: {
            title: 'Filter by site',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/public/settings/get').then(settings => {
                        return settings.sites.sort((a,b) => a.name.localeCompare(b.name));
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true,
                placeholder: 'Show all sites'
            },
            default: () => []
        },
        sort: {
            title: 'Sort by default on',
            type: String,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return [
                        {id: 'admin', name: "Administration's sorting"},
                        {id: 'name', name: 'Category name'},
                        {id: 'created', name: 'Newly added'},
                    ].map(x => ({...x, name: window.$translate(x.name)}));
                },
                text: 'name',
                value: 'id',
                multiple: false
            },
            default: () => 'admin'
        },
        showSortFilter: {
            title: 'Show sorting filter for customer',
            type: Boolean,
            default: true
        },
        link: {
            title: 'Page with course list',
            type: String,
            fulltype: 'page'
        }
    },

    components: {
        CategoryCard,
        CardLayout
    },

    data: () => ({
        unsubscribe: null
    }),

    computed: {
        sortFn() {
            if (this.sort == 'name') {
                return (a,b) => a.name.localeCompare(b.name);
            } else if (this.sort == 'created') {
                return (a,b) => Date.newFull(b.created) - Date.newFull(a.created)
            }

            return null;
        },
        categories() {
            let coursecategories = this.$store.state.settings?.coursecategories;
            if (!coursecategories) {
                return [];
            }

            let result = coursecategories.filter(c => {
                if (!this.onlyShowCategories || this.onlyShowCategories.length == 0) {
                    return true;
                }

                return this.onlyShowCategories.includes(c.id);
            });

            if (this.sortFn) {
                result.sort(this.sortFn);
            }

            return result;
        }
    },
    mounted() {
        this.unsubscribe = this.$root.$api.subscribe({type: 'coursecategory', callback: () => this.$api.reloadSettings()})
    },
    destroyed() {
        this.unsubscribe?.();
    }
}
</script>
